import { render, staticRenderFns } from "./ps-widget.vue?vue&type=template&id=293142c8"
import script from "./ps-widget.vue?vue&type=script&lang=js"
export * from "./ps-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports